export const MSG_CONSTANTS = {
  ERRORS: {
    INSUFFICIENT_DATA:
      "The action could not be performed due to insufficient or incomplete data",
    NON_DRAFT_STATUS: "Cannot submit because the status is not DRAFT.",
    CREATOR_ONLY: "Only created User Can submit the Notification",
    NO_LEVEL_ACCESS:
      "The action could not be performed because the user does not have access to this level of notification.",
    EXPIRED_NOTIFICATION:
      "The action could not be performed because the notification's expiry date has passed.",
    ASSIGNED_USER_ONLY:
      "This action could not be performed as it is restricted to the assigned user.",
    ADMIN_NO_LEVEL_ACCESS:
      "The action could not be performed because the user does not have access to this level of notification.",
  },

  ACTIONS: {
    SUBMIT: "Click to submit.",
    PUBLISH: "Click to Publish.",
    PUBLISH_EXPIRED_LEVEL2: "Click here to edit the date and publish.",
    REJECT: "Click to Reject",
    ASSIGN: "Click to Assign.",
    REASSIGN: "Click to Reassign",
    RECALL: "Click to Recall.",
  },
};
